import { MatDialogConfig } from '@angular/material/dialog';

export const detailModalConfig: MatDialogConfig = {
  data: { isDetailModal: true },
  disableClose: true,
  panelClass: ['detail-modal'],
};
